import React from 'react'
import logo from './logo.svg'
import Grid2 from '@mui/material/Unstable_Grid2'
import Container from '@mui/material/Container'
import { UsersTable } from '../components/users_table'
import AddEntryComponent from '../components/add_entry'
import { SnackbarProvider } from 'notistack'
import { SheduledSMSTable } from '../components/sheduled_sms_table'
import ButtonAppBar from '../components/app_bar'

const AddDocumentPage = () => {
    return (
        <SnackbarProvider maxSnack={3}>
            <ButtonAppBar />
            <Container sx={{
                '& .MuiTextField-root': { width: '22ch' },
            }} maxWidth={false}>
                <Grid2 container lg={6} p={5} spacing={4}>
                    {/* <Grid2 sm={12}> */}
                        <AddEntryComponent />
                    {/* </Grid2> */}
                    {/* <Grid2 lg={4}>
                        <AddEntryComponent />
                    </Grid2>
                    <Grid2 lg={8}>
                        <UsersTable />
                    </Grid2> */}
                </Grid2>

            </Container>
        </SnackbarProvider>

    )
}

export default AddDocumentPage
